import helpers from './helpers.js';

export default (function () {
  return {
    init() {
      if (document.querySelectorAll('.ie9').length) return;
      const revealItems = document.querySelectorAll('.js-reveal');

      [...revealItems].forEach((item) => {
        helpers.removeClass(item, 'js-reveal');
        helpers.addClass(item, 'reveal-in');

        const animateIn = () => {
          if (item.getAttribute('data-animtriggered') === 'true') {
            return;
          }

          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const h = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

          if (helpers.offset(item).top < scrollTop + (h / 3)) {
            item.setAttribute('data-animtriggered', 'true');

            helpers.prefixedEvent(item, 'animationend', (e) => {
              e.stopPropagation();
              helpers.removeClass(item, 'reveal-in reveal-in--ready');
            });
            helpers.addClass(item, 'reveal-in--ready');
          }
        };

        window.addEventListener('scroll', animateIn);
        animateIn();
      });
    },
  };
}());
